import { CardContent, Grid, ListItem, ListItemText, Typography } from '@mui/material';
import { Fragment, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthorizationSystemMenu } from 'shell/components/navbar/collapse-item';
import { PmiCard } from 'shell/components/shared/card';
import PmiTitle from 'shell/components/shared/title';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { DisabledMenu } from 'shell/view-models/disabled-menu';
import GeographicMenu from './geographic-menu';
import AmministrationMenu from './amministration-menu';
import { useRouteAuthorization } from 'shell/hooks/use-route-authorization';
import { systemRoutes } from 'system/router/routing-config';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonSystemCrumbs } from 'system/constants/breadcrumb';
import EventsMenu from './events-menu';

import PlatformBatchMenu from './batch-management';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import ToponomyMenu from './toponomy-menu';
export interface DisabledMenuAuthorization extends DisabledMenu {
  toponymy: boolean;
  batch: boolean;
  job: boolean;
  batchUploadFile: boolean;
  batchDownloadFile: boolean;
  pecManagement: boolean;
}

const HomePage = (): React.ReactElement => {
  const { userProfile } = useUserProfile();

  const visibility = useActionAuthorization<DisabledMenuAuthorization>(AuthorizationSystemMenu);

  const [profilingSubmenuAnchor, setProfilingSubmenuAnchor] = useState<null | HTMLElement>(null);

  const isProfilingSubmenuVisible = Boolean(profilingSubmenuAnchor);

  const [geographicSubmenuAnchor, setGeographicSubmenuAnchor] = useState<null | HTMLElement>(null);

  const [eventsSubmenuAnchor, setEventsSubmenuAnchor] = useState<null | HTMLElement>(null);

  const [toponomySubmenuAnchor, setToponomySubmenuAnchor] = useState<null | HTMLElement>(null);

  const isToponomySubMenuVisibile = Boolean(toponomySubmenuAnchor);

  const isGeographicSubmenuVisible = Boolean(geographicSubmenuAnchor);

  const isEventsSubMenuVisibile = Boolean(eventsSubmenuAnchor);

  const [batchPlatformSubmenuAnchor, setBatchPlatformSubmenuAnchor] = useState<null | HTMLElement>(
    null
  );

  const isBatchPlatformVisible = Boolean(batchPlatformSubmenuAnchor);

  const items =
    useRouteAuthorization(systemRoutes[0].children[0].children)?.filter((route) => !route.hidden) ||
    [];

  const handleBatchPlatformMenuClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setBatchPlatformSubmenuAnchor(event.currentTarget);
    },
    [setBatchPlatformSubmenuAnchor]
  );

  const handleProfilingMenuClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setProfilingSubmenuAnchor(event.currentTarget);
    },
    [setProfilingSubmenuAnchor]
  );

  const handleBatchPlatformSubmenuClose = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      return setBatchPlatformSubmenuAnchor(null);
    },
    [setProfilingSubmenuAnchor]
  );

  const handleProfilingSubmenuClose = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      setProfilingSubmenuAnchor(null);
    },
    [setProfilingSubmenuAnchor]
  );

  const handleGeographicMenuClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setGeographicSubmenuAnchor(event.currentTarget);
    },
    [setGeographicSubmenuAnchor]
  );

  const handleGeographicSubmenuClose = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      return setGeographicSubmenuAnchor(null);
    },
    [setGeographicSubmenuAnchor]
  );

  const handleEventsMenuClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setEventsSubmenuAnchor(event.currentTarget);
    },
    [setEventsSubmenuAnchor]
  );

  const handleEventsSubmenuClose = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      return setEventsSubmenuAnchor(null);
    },
    [setEventsSubmenuAnchor]
  );

  const handleToponomyMenuClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setToponomySubmenuAnchor(event.currentTarget);
    },
    [setToponomySubmenuAnchor]
  );

  const handleToponomySubmenuClose = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      return setToponomySubmenuAnchor(null);
    },
    [setToponomySubmenuAnchor]
  );

  return (
    <Fragment>
      <Breadcrumbs items={CommonSystemCrumbs} />
      <PmiTitle title="Sistema" paddingBottom={1} />
      <div className="pmi-mb-4">
        <Typography component="div" fontSize=".9rem" color="primary">
          {"Seleziona l'area di amministrazione sistema su cui operare"}
        </Typography>
      </div>
      <Grid container spacing={2}>
        {(!visibility.group && !visibility.profile && (items?.length || 0) === 0) ||
        userProfile.datiLogin?.profile?.feature?.sistema === '0' ? undefined : (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleProfilingMenuClick}>
              <CardContent>
                <AmministrationMenu
                  visibility={visibility}
                  isSubmenuVisible={isProfilingSubmenuVisible}
                  onClick={handleProfilingMenuClick}
                  onClose={handleProfilingSubmenuClose}
                  submenuAnchor={profilingSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        )}
        {(!visibility.municipality &&
          !visibility.state &&
          !visibility.region &&
          !visibility.province &&
          !visibility.territory &&
          !visibility.consulate) ||
        userProfile.datiLogin?.profile?.feature?.gestioneGeografiche === '0' ? undefined : (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleGeographicMenuClick}>
              <CardContent>
                <GeographicMenu
                  visibility={{
                    municipality: visibility.municipality,
                    region: visibility.region,
                    state: visibility.state,
                    province: visibility.province,
                    territory: visibility.territory,
                    consulate: visibility.consulate,
                  }}
                  isSubmenuVisible={isGeographicSubmenuVisible}
                  onClick={handleGeographicMenuClick}
                  onClose={handleGeographicSubmenuClose}
                  submenuAnchor={geographicSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        )}
        {!visibility.toponymy ||
        userProfile.datiLogin?.profile?.feature?.gestioneToponomastica === '0' ? undefined : (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleToponomyMenuClick}>
              <CardContent>
                <ToponomyMenu
                  visibility={{
                    territorialArea: visibility.toponymy,
                    circulationArea: visibility.toponymy,
                  }}
                  isSubmenuVisible={isToponomySubMenuVisibile}
                  onClick={handleToponomyMenuClick}
                  onClose={handleToponomySubmenuClose}
                  submenuAnchor={toponomySubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        )}
        {!visibility.eventType &&
        !visibility.eventRegistration &&
        !visibility.subscriber &&
        !visibility.searchPublishedEvents &&
        !visibility.searchEventsInError &&
        !visibility.managementNonRecoverableErrors ? undefined : (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleEventsMenuClick}>
              <CardContent>
                <EventsMenu
                  visibility={{
                    eventType: visibility.eventType,
                    destinationType: visibility.destinationType,
                    subscriber: visibility.subscriber,
                    eventRegistration: visibility.eventRegistration,
                    searchPublishedEvents: visibility.searchPublishedEvents,
                    searchEventsInError: visibility.searchEventsInError,
                    managementNonRecoverableErrors: visibility.managementNonRecoverableErrors,
                  }}
                  isSubmenuVisible={isEventsSubMenuVisibile}
                  onClick={handleEventsMenuClick}
                  onClose={handleEventsSubmenuClose}
                  submenuAnchor={eventsSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        )}
        {!visibility.job && !visibility.batch ? undefined : (
          <Grid item xs={12} md={4}>
            <PmiCard>
              <CardContent>
                <PlatformBatchMenu
                  visibility={visibility}
                  isSubmenuVisible={isBatchPlatformVisible}
                  onClick={handleBatchPlatformMenuClick}
                  onClose={handleBatchPlatformSubmenuClose}
                  submenuAnchor={batchPlatformSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        )}
        {!visibility.pecManagement ? undefined : (
          <Grid item xs={12} md={4}>
            <Link to="/sistema/pec" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Gestione PEC" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        )}
      </Grid>
    </Fragment>
  );
};

HomePage.displayName = 'home page component';

export default HomePage;
